import React, { Component } from 'react'
import * as actions from '../../actions'
import { EMPTY_CUPO_NOMINACION } from '../../actions/constants'
import { connect } from 'react-redux'
import { RenominacionDeCuposDialogView } from '../../components/renominacionCupos/RenominaciónDeCuposDialogView'
import { reduxForm } from 'redux-form'
import { FORM_NOMINACION_CUPO } from '../../../../config/forms'
import DialogView from '../../../Dialogos/DialogView'

class RenominacionDeCuposDialog extends Component {
  render () {
    const { confirmCallback, cancelCallback } = this.props
    return (
      <DialogView
        confirmCallback={confirmCallback}
        cancelCallback={cancelCallback}
        title='Modificar cupos nominados'
        content={<RenominacionDeCuposDialogView
          currentCupo={this.props.cupoRenominacion}
          buscarCorreoCuitCargador={this.props.buscarCorreoCuitCargador}
          buscarCorreoCuitCorredor={this.props.buscarCorreoCuitCorredor}
          resetCorreoCargador={this.props.resetCorreoCargador}
          resetCorreoCorredor={this.props.resetCorreoCorredor}
        />
        }
      />
    )
  }
}

const mapStateToProps = state => {
  return {
    cupoRenominacion: state.cupos.cupoRenominacion
  }
}

export default connect(mapStateToProps, actions)(reduxForm({
  form: FORM_NOMINACION_CUPO,
  initialValues: EMPTY_CUPO_NOMINACION,
  enableReinitialize: true
})(RenominacionDeCuposDialog))
